import React from 'react';
import { Grant } from '../../../../generated/graphql';

type Props = {
  grants: Grant[];
  onFixClick?: () => void; 
};

export const FMVWarningBox: React.FC<Props> = ({ grants, onFixClick }) => {
  const hasMissingFMV = grants.some((grant) => !grant.companyFMV || grant.companyFMV === 0);

  if (!hasMissingFMV) return null;

  const handleFixClick = () => {
    if (onFixClick) {
      onFixClick(); 
    }
  };

  return (
    <div
      className='d-flex align-items-start justify-content-between p-4 mb-4 rounded border '
      style={{
        backgroundColor: '#fbf7f0',
        borderColor: '1px solid #fbe6c3',
        color: '#f5a10a',
      }}
    >
      <div className='d-flex align-items-start gap-3' >
        <img
          src='/media/custom-images/warning.svg'
          alt='Warning Icon'
          className='svg-icon-2hx mt-1'
        />
        <div>
          <div className='fw-bold text fs-6 ' >
            📣 Some of your grants are missing FMV. Add FMV to unlock full insights.
          </div>
          <div className='text-muted fs-7'>
            FMV is needed to calculate Unrealized Value, Expiry Risk, and Tax Estimates.
          </div>
        </div>
      </div>
      <button
  className='btn btn-sm fw-semibold rounded'
  style={{
    border: '1px solid #f5a10a',
    color: '#f5a10a',
  }}
  onClick={handleFixClick}
>
  Fix Now
</button>

    </div>
  );
};